import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoClose24 } from '@onefootprint/icons';
import { IconButton, useConfirmationDialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import type { NavigationHeaderCloseButtonProps } from '../../types';
type NavigationCloseButtonProps = Omit<NavigationHeaderCloseButtonProps, 'variant'> & {
  onClose?: () => void;
  color?: Color;
};
const NavigationCloseButton = t0 => {
  const $ = _c(15);
  const {
    onClose,
    confirmClose,
    color
  } = t0;
  const confirmationDialog = useConfirmationDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "shell.global.components.confirmation-dialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "shell.global.components.navigation-header"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tHeader
  } = useTranslation("idv2", t2);
  let t3;
  if ($[2] !== confirmClose || $[3] !== confirmationDialog || $[4] !== onClose || $[5] !== t) {
    t3 = () => {
      if (!confirmClose) {
        onClose?.();
        return;
      }
      confirmationDialog.open({
        title: t(_temp),
        description: t(_temp2),
        primaryButton: {
          label: t(_temp3),
          onClick: onClose
        },
        secondaryButton: {
          label: t(_temp4)
        }
      });
    };
    $[2] = confirmClose;
    $[3] = confirmationDialog;
    $[4] = onClose;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleClick = t3;
  let t4;
  if ($[7] !== tHeader) {
    t4 = tHeader(_temp5);
    $[7] = tHeader;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== color) {
    t5 = props => <IcoClose24 {...props} color={color ?? "primary"} />;
    $[9] = color;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleClick || $[12] !== t4 || $[13] !== t5) {
    t6 = <IconButton className={TOUCH_TARGET_CLASS} aria-label={t4} onClick={handleClick} icon={t5} />;
    $[11] = handleClick;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default NavigationCloseButton;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.description;
}
function _temp3($_1) {
  return $_1.confirm;
}
function _temp4($_2) {
  return $_2.cancel;
}
function _temp5($_3) {
  return $_3["close-button"]["aria-label"];
}